import React from 'react'
import { CONDITION_ITEMS } from '../../constants/conditions'
import { ConditionName } from '../../actions'
import { css } from '@emotion/react'
import { colors } from 'plume-ui'
import { IcomoonIcon } from '../../../../atoms/IcomoonIcon'

type Props = {
  name: ConditionName
  annotation?: string | null
  error: boolean
  from?: number
  to?: number
  onRemove: (cond: ConditionName) => any
  onToggle: (cond: ConditionName) => any
}

const RangeConditionLabel = ({
  name,
  annotation,
  error,
  from,
  to,
  onRemove,
  onToggle,
}: Props) => {
  const labelName = CONDITION_ITEMS[name].label
  const an = annotation ? ` (${annotation})` : ''
  const prepend = from ? `${from}${an} ≦ ` : undefined
  const append = to ? ` ≦ ${to}${an}` : undefined
  const s = prepend ? prepend + labelName : labelName
  const text = append ? s + append : s

  const icon =
    from || to ? (
      <span
        onClick={() => onRemove(name)}
        css={css`
          margin-left: 5px;
        `}
      >
        <i
          className="icomoon icon-close1 right"
          css={css`
            font-size: 10px;
            color: ${colors.white10}
            &:before {
              font-size: 0.65rem;
              margin-left: 5px;
            }
          `}
        />
      </span>
    ) : (
      // <i className="icomoon icon--arrow3-down right" />
      <IcomoonIcon
        name="arrow8-down"
        css={css`
          font-size: 10px;
          color: ${colors.white10};
          &:before {
            font-size: 0.65rem;
            margin-left: 5px;
          }
        `}
      />
    )

  const content = error ? (
    <span>
      <i
        className="icomoon icon-alert-fill left"
        css={css`
          &:before {
            margin-right: 3px;
          }
        `}
      />
      {labelName}
    </span>
  ) : (
    text
  )

  return (
    <li
      className="condition-label"
      onClick={() => onToggle(name)}
      css={css`
        padding: 5px 10px 5px 15px;
        cursor: pointer;
      `}
    >
      {content}
      {icon}
    </li>
  )
}

export default RangeConditionLabel
